// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3ClPU","label":"Category_label__XUs5C","content":"Category_content__28qkb","header":"Category_header__19HMV","location":"Category_location__1pOq9"};